import { render, staticRenderFns } from "./TearOffCalendarIcon.vue?vue&type=template&id=1900911c"
import script from "./TearOffCalendarIcon.vue?vue&type=script&lang=js"
export * from "./TearOffCalendarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports